// extracted by mini-css-extract-plugin
export default {"tableWrapper":"table-wrapper--VfAiif9RRfqPEBILPBqz","tableWrapReview":"table-wrap-review--GZ9OggVNeivFzijnVWJP"};